import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';
import { ItemTipoSituacao, itemTipoAtivo, itemTipoInativo } from '../situacao';

/** Representa o Filter da entidade ItemTipo */
export class ItemTipoFilter implements Filter {
    filterPsq: string;
    situacao: number;
    situacoes: number[] = [];

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }
        // Situação
        if (this.situacao) {
            params = params.append('situacao', this.situacao.toString());
        }
        this.situacoes?.forEach(situacao => params = params.append('situacao', situacao.toString()));

        return params;
    }

    clear() {
        this.filterPsq = null;
        this.situacao = null;
    }

    /** Adiciona a situação informada ao filtro */
    private withSituacao(situacao: ItemTipoSituacao): ItemTipoFilter {
        if (!situacao) {
            return;
        }

        if (!this.situacoes) {
            this.situacoes = [];
        }
        this.situacoes.push(situacao.id);

        return this;
    }

    /** Adiciona a situação Ativo ao filtro */
    withAtivo(): ItemTipoFilter {
        return this.withSituacao(itemTipoAtivo);
    }

    /** Adiciona a situação Inativo ao filtro */
    withInativo(): ItemTipoFilter {
        return this.withSituacao(itemTipoInativo);
    }
}

